/**
 * Agent availability filter — shared by Status page and Agent Presence widgets.
 */
export type AgentStatusFilter = 'all' | 'available' | 'unavailable';

export function isAvailableStatus(ipscapeStatus: string): boolean {
  const s = ipscapeStatus.toLowerCase();
  return ['available', 'online', 'registered'].includes(s);
}

export function filterAgentsByStatus<T extends { ipscapeStatus: string }>(
  agents: T[],
  filter: AgentStatusFilter
): T[] {
  if (filter === 'all') return agents;
  if (filter === 'available') return agents.filter((a) => isAvailableStatus(a.ipscapeStatus));
  return agents.filter((a) => !isAvailableStatus(a.ipscapeStatus));
}
